import { render, staticRenderFns } from "./DataWZD.vue?vue&type=template&id=a1e39e2c&scoped=true&"
import script from "./DataWZD.vue?vue&type=script&lang=js&"
export * from "./DataWZD.vue?vue&type=script&lang=js&"
import style0 from "./DataWZD.vue?vue&type=style&index=0&id=a1e39e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e39e2c",
  null
  
)

export default component.exports